import { Serializable } from '../../../core/models/serializable';
import { CustomerBrandingAccessTokenStatus } from './customer-branding-access-token-status.enum';
import { StoreItemModel } from './store-item-model';

export class CustomerBrandingAccessTokenModel
  implements Serializable<CustomerBrandingAccessTokenModel>
{
  customerBrandingAccessTokenId: number;
  statusId: CustomerBrandingAccessTokenStatus;

  tokenExpireDate?: Date;
  createDate?: Date;
  processDate?: Date;
  terminateDate?: Date;

  customerId: number;
  customerName: string;
  storeItem: StoreItemModel;
  storeItemId: number;

  portfolioId: number;
  portfolioName: string;
  portfolioAccountManagerName: string;

  fromObject(object: any): CustomerBrandingAccessTokenModel {
    Object.assign(this, object);

    if (object.storeItem != null) {
      const s = new StoreItemModel();
      this.storeItem = s.fromObject(object.storeItem);
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
